<template>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group">
                <label>{{ translations.first_name }}</label>
                <input type="text"
                       name="first_name"
                       class="form-control"
                       v-model="userData.first_name"/>
            </div>
            <div class="form-group">
                <label>{{ translations.last_name }}</label>
                <input type="text"
                       name="last_name"
                       class="form-control"
                       v-model="userData.last_name"/>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-12">
                        <label>{{ translations.phone }}</label>
                        <input type="text"
                               name="phone"
                               class="form-control"
                               v-model="userData.phone"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group">
                <label>{{ translations.location }}</label>
                <select2
                    name="location_id"
                    value_key="id"
                    title_key="title"
                    @selected="setLocation"
                    :items="locations"
                    :selected="userData.location_id"
                    :placeholder="translations.choose_country"
                />
            </div>

            <div class="form-group" v-if="selected_location && selected_location.children.length">
                <label>{{ translations.sub_location }}</label>
                <select2
                    name="sub_location_id"
                    value_key="id"
                    title_key="title"
                    @selected="setSubLocation"
                    :items="selected_location.children"
                    :selected="userData.sub_location_id"
                    :placeholder="translations.choose_country"
                />
            </div>
            <div class="form-group" v-else>
                <label>{{ translations.sub_location }}</label>
                <input type="text"
                       name="sub_location"
                       class="form-control"
                       v-model="userData.sub_location"/>
            </div>

            <div class="form-group">
                <label>{{ translations.city }}</label>
                <input type="text"
                       name="city"
                       class="form-control"
                       v-model="userData.city"/>
            </div>
            <div class="form-group">
                <label>{{ translations.address }}</label>
                <input type="text"
                       name="address"
                       class="form-control"
                       v-model="userData.address"/>
            </div>
            <div class="form-group">
                <label>{{ translations.index }}</label>
                <input type="text"
                       name="postcode"
                       class="form-control"
                       v-model="userData.postcode"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['user', 'locations', 'translations'],
        data() {
            return {
                userData: this.user
            };
        },
        computed: {
            selected_location() {
                return this.locations.find((location) => {
                    return location.id === this.userData.location_id;
                });
            }
        },
        methods: {
            setLocation(location) {
                this.userData.location_id = location.id;
            },
            setSubLocation(subLocation) {
                this.userData.sub_location_id = subLocation.id;
            },
        }
    }
</script>
